import React from 'react'
import Reflux from 'reflux'
import _ from 'lodash'
import FontAwesome from 'react-fontawesome'
import { Container, Row, Col } from 'reactstrap'

import RecipesStore from '~/stores/recipes.js'
import ShoppingListStore from '~/modules/shoppingList/listStore.js'
import ShoppingListActions from '~/modules/shoppingList/listActions.js'

import Loading from '~/modules/_shared/loading.jsx'


export default class ShoppingListQuantities extends Reflux.Component {
	constructor(props) {
		super(props)

		this.stores = [
			ShoppingListStore,
			RecipesStore
		]
	}

	render() {
		const mappedQuantities = this.state.shoppingList.map(
			x => (
				<Row key={x.recipeID}>
					<Col xs={12}>
						<table>
							<tbody>
								<tr>
									{
										x.status === 'LOADING' &&

										<td>
											<Loading />
											{' '}
											{
												(this.state.list.length > 0)
													? _.find(this.state.list, { recipeID: x.recipeID }).recipe
													: '(loading)'
											}
										</td>
									}
									{
										x.status === 'COMPLETE' &&

										<React.Fragment>
											<td>
												<button
													onClick={() => ShoppingListActions.qtyLess(x.recipeID)}
													disabled={x.quantity === 1}
												>
													<FontAwesome name="minus" />
												</button>
											</td>
											<td style={{ width: '3em', textAlign: 'right' }}>
												{x.quantity}
											</td>
											<td>
												<button
													onClick={() => ShoppingListActions.qtyMore(x.recipeID)}
													disabled={x.quantity === 9}
												>
													<FontAwesome name="plus" />
												</button>
											</td>
											<td>
												{' '}
											</td>
											<td>
												{
													(this.state.list.length > 0)
														? _.find(this.state.list, { recipeID: x.recipeID }).recipe
														: '(loading)'
												}
											</td>
											<td>
												{' '}
											</td>
											<td>
												<button
													onClick={() => ShoppingListActions.delete(x.recipeID)}
													style={{ backgroundColor: 'transparent', border: '0 none' }}
												>
													<FontAwesome
														name="times"
														style={{ color: '#f66' }}
													/>
												</button>
											</td>
										</React.Fragment>
									}
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>
			)
		)

		return (
			<Container>
				{mappedQuantities}
			</Container>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/quantities.jsx